function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import RichTextEditor from 'react-rte';
import { cmsActions } from '../../reducers/cms.reducer';
import ArticlesEditData from './add/ArticlesEditData.context';
import Permission from '../common/Permission.react';
import ArticleAlert from './add/ArticleAlert.react';
import ArticleDetails from './add/ArticleDetails.react';
import ArticleImages from './add/ArticleImages.react';
import ArticleSlideshow from './add/ArticleSlideshow.react';
import ArticleParagraph from './add/ArticleParagraph.react';
import ArticleSidebarImage from './add/ArticleSidebarImage.react';
import ArticleType from './add/ArticleType.react';
import ArticleSidebarDetails from './add/ArticleSidebarDetails.react';
import ArticleContacts from './add/ArticleContacts.react';
import ArticleDelete from './add/ArticleDelete.react';
import ArticleVideo from './add/ArticleVideo.react';
import ArticleCareer from './add/ArticleCareer.react';
import ArticleProjectIcons from './add/ArticleProjectIcons.react';
import ArticleOurTeam from './add/ArticleOurTeam.react';
import ArticleSEO from './add/ArticleSEO.react';

// TODO :: Stop if app / type is not in constants
var ArticlesAdd = function ArticlesAdd(_ref) {
  var articlesAction = _ref.articlesAction,
    assetsAction = _ref.assetsAction;
  var _useParams = useParams(),
    app = _useParams.app,
    articleID = _useParams.articleID;
  var navigate = useNavigate();
  var articles = useSelector(function (s) {
    return s.cms.articles || {};
  });
  var pages = useSelector(function (s) {
    return s.pos.pages || {};
  });
  var _useState = useState({
      page: {},
      article: null,
      articleType: 'default',
      breadcrumbs: '',
      title: '',
      subtitle: '',
      hero: [],
      breadcrumbsAsTitle: false,
      paragraph: RichTextEditor.createEmptyValue(),
      secondParagraph: '',
      showSecondParagraph: false,
      sidebar: {},
      contacts: [],
      showProductBuyLink: false,
      slideshow: [],
      videoArticle: {},
      careerArticle: {},
      projectIcons: [],
      ourTeamArticle: {},
      metadata: null,
      archived: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    if (articleID) articlesAction({
      formData: {
        articleID: articleID
      }
    });
  }, [articleID]);
  useEffect(function () {
    assetsAction({});
  }, []);
  useEffect(function () {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      page: pages
    }));
  }, [articleID, articles, pages]);
  useEffect(function () {
    if (articleID && articles && articles[articleID]) {
      var _articles$articleID = articles[articleID],
        title = _articles$articleID.title,
        articleType = _articles$articleID.type,
        hero = _articles$articleID.hero,
        paragraph = _articles$articleID.paragraph,
        secondParagraph = _articles$articleID.secondParagraph,
        showSecondParagraph = _articles$articleID.showSecondParagraph,
        breadcrumbs = _articles$articleID.breadcrumbs,
        subtitle = _articles$articleID.subtitle,
        sidebar = _articles$articleID.sidebar,
        newsDate = _articles$articleID.newsDate,
        showProductBuyLink = _articles$articleID.showProductBuyLink,
        contacts = _articles$articleID.contacts,
        slideshow = _articles$articleID.slideshow,
        videoArticle = _articles$articleID.videoArticle,
        careerArticle = _articles$articleID.careerArticle,
        projectIcons = _articles$articleID.projectIcons,
        ourTeamArticle = _articles$articleID.ourTeamArticle,
        metadata = _articles$articleID.metadata,
        _archived = _articles$articleID.archived;
      setState(_objectSpread(_objectSpread({}, state), {}, {
        article: _objectSpread({}, articles[articleID]),
        title: title,
        articleType: articleType,
        articleID: articleID,
        hero: hero,
        paragraph: (paragraph === null || paragraph === void 0 ? void 0 : paragraph.length) > 0 ? RichTextEditor.createEmptyValue().setContentFromString(paragraph, 'html') : RichTextEditor.createEmptyValue(),
        secondParagraph: (secondParagraph === null || secondParagraph === void 0 ? void 0 : secondParagraph.length) > 0 ? RichTextEditor.createEmptyValue().setContentFromString(secondParagraph, 'html') : RichTextEditor.createEmptyValue(),
        showSecondParagraph: showSecondParagraph,
        breadcrumbs: breadcrumbs,
        subtitle: subtitle,
        breadcrumbsAsTitle: (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) > 0 && breadcrumbs === title,
        sidebar: sidebar || {},
        newsDate: newsDate,
        contacts: contacts,
        slideshow: slideshow,
        showProductBuyLink: showProductBuyLink,
        videoArticle: videoArticle || {},
        careerArticle: careerArticle || {},
        projectIcons: projectIcons || [],
        ourTeamArticle: ourTeamArticle || {},
        metadata: metadata || null,
        archived: _archived
      }));
    }
  }, [articleID, articles]);
  var archived = state.archived;
  return /*#__PURE__*/React.createElement(ArticlesEditData.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, app && /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--back",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return navigate("/".concat(app, "/articles"));
    }
  }, "back")), /*#__PURE__*/React.createElement(ArticleAlert, null), /*#__PURE__*/React.createElement(ArticleType, null), /*#__PURE__*/React.createElement(ArticleDetails, null), /*#__PURE__*/React.createElement(ArticleSEO, null), /*#__PURE__*/React.createElement(ArticleImages, null), /*#__PURE__*/React.createElement(ArticleOurTeam, null), /*#__PURE__*/React.createElement(ArticleProjectIcons, null), /*#__PURE__*/React.createElement(ArticleSlideshow, null), /*#__PURE__*/React.createElement(ArticleContacts, null), /*#__PURE__*/React.createElement(ArticleVideo, null), /*#__PURE__*/React.createElement(ArticleParagraph, null), /*#__PURE__*/React.createElement(ArticleSidebarDetails, null), /*#__PURE__*/React.createElement(ArticleCareer, null), /*#__PURE__*/React.createElement(ArticleSidebarImage, null), !archived && /*#__PURE__*/React.createElement(Permission, {
    permission: "edit-pos-articles"
  }, /*#__PURE__*/React.createElement(ArticleDelete, null))));
};
var mdtp = {
  articlesAction: cmsActions.articles,
  assetsAction: cmsActions.assets
};
export default connect(null, mdtp)(ArticlesAdd);